import { api } from "@/lib/axios";
import { Campaign } from "@/types/project";

const get = (): Promise<Campaign[]> =>
  api.get("/campaigns").then((r) => r.data);

export default get;
